import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";

function SelectCriteriaForm(props) {
  const {
    employeeList,
		selectedEmployee,
		onEmployeeChange,
    months,
    selectedMonth,
    onMonthChange,
    years,
    selectedYear,
    onYearChange,
  } = props;
  return (
    <>
      <Row className="row-one">
        <Col lg={4}>
                    <Form.Group className="d-flex align-items-center m-0">
                      <Form.Label className="mb-0 mr-5">
                        Employee
                      </Form.Label>
                      <CustomReactSelect
                        options={employeeList}
                        onChange={(obj) => onEmployeeChange(obj)}
                        value={selectedEmployee}
                        className="dropDown"
                        placeholder="Select"
                      />
                    </Form.Group>
                  </Col>
        <Col lg={4}>
          <Form.Group className="d-flex align-items-center m-0">
            <Form.Label className="mb-0 mr-5">Month</Form.Label>
            <CustomReactSelect
              className="dropDown"
              options={months}
              value={selectedMonth}
              onChange={(value) => onMonthChange(value)}
            />
          </Form.Group>
        </Col>
        <Col lg={4}>
          <Form.Group className="d-flex align-items-center m-0">
            <Form.Label className="mb-0 mr-5">Year</Form.Label>
            <CustomReactSelect
              className="dropDown"
              options={years}
              value={selectedYear}
              onChange={(value) => onYearChange(value)}
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
}

export default SelectCriteriaForm;
